import { Link } from 'react-router-dom';
import { categories } from '@/mocks/videos';
import { aboutData } from '@/mocks/about';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-200 border-t border-background-300">
      <div className="w-full px-4 md:px-6 py-12 md:py-14">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            {/* Brand */}
            <div className="col-span-2 lg:col-span-1">
              <Link to="/" className="flex items-center gap-2 mb-4 cursor-pointer">
                <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
                  <i className="ri-play-fill text-foreground-950 text-lg"></i>
                </div>
                <span className="text-xl font-bold text-foreground-950">蓝莓视频</span>
              </Link>
              <p className="text-sm text-foreground-500 leading-relaxed mb-4">
                高清免费在线视频平台，海量影视资源，流畅观影体验。91视频、97视频等平台的优质替代选择。
              </p>
              <div className="flex items-center gap-3">
                <a href="#" className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-300 text-foreground-500 hover:text-primary-500 hover:bg-primary-500/10 transition-all cursor-pointer" aria-label="微博">
                  <i className="ri-weibo-line"></i>
                </a>
                <a href="#" className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-300 text-foreground-500 hover:text-primary-500 hover:bg-primary-500/10 transition-all cursor-pointer" aria-label="微信">
                  <i className="ri-wechat-line"></i>
                </a>
                <a href="#" className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-300 text-foreground-500 hover:text-primary-500 hover:bg-primary-500/10 transition-all cursor-pointer" aria-label="哔哩哔哩">
                  <i className="ri-bilibili-line"></i>
                </a>
              </div>
            </div>

            {/* Categories */}
            <div>
              <h4 className="text-sm font-semibold text-foreground-900 mb-4">
                <a href="#categories" className="hover:text-primary-500 transition-colors">视频分类</a>
              </h4>
              <ul className="space-y-2">
                {categories.map((cat) => (
                  <li key={cat.slug}>
                    <Link
                      to={`/category/${cat.slug}`}
                      className="text-sm text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer"
                    >
                      {cat.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* Quick Links */}
            <div>
              <h4 className="text-sm font-semibold text-foreground-900 mb-4">快速链接</h4>
              <ul className="space-y-2">
                <li>
                  <Link to="/" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">
                    首页推荐
                  </Link>
                </li>
                <li>
                  <Link to="/category/dianshiju" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">
                    热门电视剧
                  </Link>
                </li>
                <li>
                  <Link to="/category/dianying" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">
                    最新电影
                  </Link>
                </li>
                <li>
                  <Link to="/category/zongyi" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">
                    热门综艺
                  </Link>
                </li>
                <li>
                  <Link to="/about" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">
                    关于我们
                  </Link>
                </li>
              </ul>
            </div>

            {/* Contact */}
            <div>
              <h4 className="text-sm font-semibold text-foreground-900 mb-4">联系我们</h4>
              <ul className="space-y-2">
                <li className="flex items-center gap-2 text-sm text-foreground-500">
                  <i className="ri-mail-line text-foreground-400"></i>
                  {aboutData.contact.email}
                </li>
                <li className="flex items-center gap-2 text-sm text-foreground-500">
                  <i className="ri-phone-line text-foreground-400"></i>
                  {aboutData.contact.phone}
                </li>
                <li className="flex items-center gap-2 text-sm text-foreground-500">
                  <i className="ri-map-pin-line text-foreground-400"></i>
                  {aboutData.contact.address}
                </li>
              </ul>
            </div>
          </div>

          {/* Bottom Bar */}
          <div className="mt-10 pt-6 border-t border-background-300 flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-foreground-400">
              &copy; {currentYear} 蓝莓视频 - 蓝莓视频数字视频平台 版权所有
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-xs text-foreground-400 hover:text-foreground-600 transition-colors">用户协议</a>
              <a href="#" className="text-xs text-foreground-400 hover:text-foreground-600 transition-colors">隐私政策</a>
              <a href="#" className="text-xs text-foreground-400 hover:text-foreground-600 transition-colors" rel="nofollow">免责声明</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}